import { ca } from '@cian/analytics';

export function trackFirstSearchInput() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'search_string',
    action: 'type_sopr',
    label: 'search_query',
  });
}
